export const MuiLink = {
    defaultProps: {
        color: 'primary',
        underline: 'none'
    },
    styleOverrides: {
        root: ({ theme })=>({
                color: theme.palette.secondary.main
            })
    }
};

//# sourceMappingURL=link.js.map